import { api } from '@/api'
import type { ApiPaginationResponse, ApiResponse } from '@/api/typings/response.typing'
import type { CommissionFilters, CommissionItem } from '@/api/typings/settings.typing'

export interface UpdateCommissionPayload {
  currency_id: string
  from: string | number
  till: string | number
  rate: string | number
  type: 'PERCENTAGE' | 'FIXED'
}

export interface CreateCommissionPayload {
  currency_id: string
  from: string | number
  till: string | number
  rate: string | number
  type: 'PERCENTAGE' | 'FIXED'
}

export function getCommissionsAction(
  filters: CommissionFilters = {}
): Promise<ApiPaginationResponse<CommissionItem[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/commissions?${params.toString()}`
  return api.get<ApiPaginationResponse<CommissionItem[]>>(url)
}

export function createCommissionAction(payload: CreateCommissionPayload) {
  return api.post<ApiResponse<unknown>>(`/commissions`, { ...payload })
}

export function updateCommissionAction(id: string | number, { ...payload }: UpdateCommissionPayload) {
  return api.put<ApiResponse<unknown>>(`/commissions/${id}`, { ...payload })
}

export function deleteCommissionAction(id: string | number) {
  return api.delete<ApiResponse<unknown>>(`/commissions/${id}`)
}
